import { initGoogleOptimize } from "../../services/googleOptimize";
import {
  UpdateWordtuneCookieWithUrlParams,
  redirectToPremiumPageForPromoCodeExtentionUsers,
} from "../../utils/common";
import { initAmplitude } from "../../services/trackingService";

function head() {
  initAmplitude();
  UpdateWordtuneCookieWithUrlParams();
  initGoogleOptimize();
  redirectToPremiumPageForPromoCodeExtentionUsers();
}

head();
